import { METHOD, requestSet } from "@/utils/request";
import md5 from 'md5'
// import { BASE_URL } from "@/services/api";

/** ****************************** 公共类数据接口 *********************************/

/**
 * 获取oss token
 * @returns {Promise<AxiosResponse<T>>
 */
export async function getToken (param) {
  return requestSet(`/center/oss/temporary/authorization/get/token`, METHOD.GET, param);
}

/**
 * 获取部门列表
 * @returns {Promise<AxiosResponse<T>>
 */
export async function apiGetDepartmentList (param) {
  return requestSet(`/center/authority/department/get`, METHOD.GET, param);
}

/**
 * 查询OA所有用户信息List
 * @param userName
 * @returns {Promise<AxiosResponse<T>>}
 */
 export async function apiQueryUserList (params) {
  return requestSet(`/authority/user/getUserByUserName`, METHOD.GET, params)
}

/**
 * 建立异步任务
 * @returns {Promise<AxiosResponse<T>>
 */
 export async function apiUcTaskEstablish (params) {
  return requestSet(`/kernel-uc/internal/ucTask/establish`, METHOD.POST, params);
}

// ====================外部接口====================
/**
 * 外部链接获取阿里云token -
 *  @returns {Promise<AxiosResponse<T>>
 */
export async function apiExternalGetToken () {
  return requestSet(`/center/external/callback/oss/temporary/authorization/get/token`, METHOD.GET);
}

// 详情-查询所有城市信息 - 外部接口
export async function apiQueryCitys () {
  return requestSet(`/center/external/callback/citys`, METHOD.GET, null);
}

/**
 * 获取阿里云token，特意做的，mom可用
 */
export async function apiMomGetToken () {
  return requestSet(`/file/oss/temporary/authorization/get/token`, METHOD.GET);
}

/**
 * 流程日志通用接口
 * @param
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function apiGetBpmLogs(params) {
  const apiKey = process.env.VUE_APP_API_SCM_GYL_URL_api_key
  const apiSecret = process.env.VUE_APP_API_SCM_GYL_URL_api_secret
  const timestamp = new Date().getTime()
  const sign = md5(apiKey.toString() + timestamp.toString() + apiSecret.toString());
  return requestSet(`${process.env.VUE_APP_API_SCM_GYL_URL}/api/kernel-flow/external/bpm/getBpmLogs?apiKey=${apiKey}&apiSecret=${apiSecret}&timestamp=${timestamp}&sign=${sign}`, METHOD.POST, params);
}
